<template>
  <BaseModal
    :title="$t('message.memberGetMember.instaModal.title')"
    modal-width="824px"
    min-height="10px"
    hookSufix="InstaMemberGetMember"
    disableDefaultPadding
    :paddingTop="'8px'"
  >
    <template #content>
      <div class="container-content">
        <div>
          <img
            :src="imgBanner"
            width="234px"
            height="349px"
            class="banner-image"
          />
        </div>
        <div class="content-column">
          <span class="body-bold-base neutral-20-dark--text">
            {{ $t('message.memberGetMember.instaModal.followInstructions') }}
          </span>
          <div class="container-button">
            <span class="body-regular-small neutral-20-dark--text">
              {{ $t('message.memberGetMember.instaModal.downloadImage') }}
            </span>
            <base-btn
              type="tertiary"
              size="small"
              class="px-2"
              @click="downloadImage"
            >
              <v-icon size="16">mdi-download</v-icon>
              {{ $t('message.download') }}
            </base-btn>
          </div>
          <div class="container-button">
            <span class="body-regular-small neutral-20-dark--text">
              {{ $t('message.memberGetMember.instaModal.copyReferralLink') }}
            </span>
            <base-btn
              type="tertiary"
              size="small"
              @click="copyToClipboard"
              class="px-2"
            >
              <v-icon size="16" class="mr-1">panda-copy</v-icon>
              {{ $t('message.memberGetMember.share.copy') }}
            </base-btn>
            <span
              class="body-regular-smaller neutral-40-light--text break-word"
            >
              {{ invite }}
            </span>
          </div>
          <span class="body-regular-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.instaModal.addImageToStories') }}
          </span>
          <span class="body-regular-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.instaModal.pasteReferralLink') }}
          </span>
          <span class="body-regular-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.instaModal.shareAndInvite') }}
          </span>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapState, mapMutations } from 'vuex'
import BaseModal from '@/components/BaseModal.vue'
// internal imports
import linkHelper from '@/utils/linkHelper.mixin.js'
// imgs
import img_pt from './Assets/img-pt.png'
import img_es from './Assets/img-es.png'
import img_en from './Assets/img-en.png'
import img_pt_us from './Assets/img-pt-usd.png'
import img_es_us from './Assets/img-es-usd.png'
import img_en_us from './Assets/img-en-usd.png'
//mixins
import logoBonificationMixin from '@/utils/logoBonification.mixin.js'
import i18n from '@/translations/lang'
export default {
  name: 'InstaMemberGetMember',
  directives: { mask },
  components: {
    BaseModal,
  },
  props: {
    invite: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: null,
    },
  },
  mixins: [linkHelper, logoBonificationMixin],
  data: () => ({
    openModalPixel: false,
    img_pt,
    img_es,
    img_en,
    img_pt_us,
    img_es_us,
    img_en_us,
    imgBanner: img_pt,
  }),
  computed: {
    ...mapState({
      userPlan: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    langCurrency() {
      return `${i18n.language}-${this.currency || this.userPlan?.currency}`
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.invite)
        .then(() => {
          this.UPDATE_GLOBAL_SNACKBAR({
            open: true,
            type: 'success',
            text: i18n.t('message.memberGetMember.share.toast'),
          })
        })
        .catch((err) => {
          console.error('Erro ao copiar:', err)
        })
    },
    applyImg(langCurrency) {
      const map = {
        'pt-br-brl': this.img_pt,
        'pt-br-usd': this.img_pt_us,
        'es-brl': this.img_es,
        'es-usd': this.img_es_us,
        'en-brl': this.img_en,
        'en-usd': this.img_en_us,
      }
      this.imgBanner =
        map[langCurrency.toLowerCase() || this.langCurrency.toLowerCase()] ||
        this.img_pt
    },
    downloadImage() {
      const link = document.createElement('a')
      link.href = this.imgBanner
      link.download = 'share.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
  mounted() {
    this.$root.$on('changeLanguage', () => {
      this.applyImg(
        `${i18n.language}-${this.currency || this.userPlan?.currency}`
      )
    })
  },
}
</script>
<style lang="scss" scoped>
.container-content {
  display: flex;
  padding: 24px;
  align-items: center;
  gap: 48px;
  border-top: 1px solid varFigma(neutral-95-lightest);
}

.container-button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.banner-image {
  border-radius: 4px;
}

.content-column {
  display: flex;
  gap: 16px;
  flex-direction: column;
  width: 60%;
}

.break-word {
  word-break: break-all;
}
</style>
